import { CORE_PERMISSIONS, USER_TYPE, getFeatureFlags, type AccessRole, type AppConfigData } from '@a1/shared';
import { aiFeaturesEnabled } from 'constants-ts/featureFlags';

const canViewQuickStart = (accessRoles: AccessRole[], appConfigData: AppConfigData | null | undefined): boolean => {
  if (!getFeatureFlags(appConfigData, { aiFeaturesEnabled }).aiFeatures) {
    return false;
  }

  return accessRoles.some((accessRole) => {
    let permissions: string[] = [];

    try {
      permissions = Array.isArray(accessRole.permissions) ? [...accessRole.permissions] : JSON.parse(accessRole.permissions);
    } catch {
      permissions = [];
    }

    return permissions.includes(CORE_PERMISSIONS.VIEW_QUICK_START);
  });
};

/**
 * Gets the page a user should land on when no specific destination was requested.
 * @param userType The type of the user.
 * @param accessRoles List of access roles assigned to the user.
 * @param appConfigData Current app configuration, used to evaluate feature flags.
 * @returns Path to be landed on.
 */
export const getDefaultLandingPath = (
  userType: USER_TYPE,
  accessRoles: AccessRole[] = [],
  appConfigData?: AppConfigData | null
): string => {
  if (canViewQuickStart(accessRoles, appConfigData)) {
    return '/quick-start';
  }

  return userType === USER_TYPE.ADMIN ? '/dashboard-booking-stats' : '/respondents';
};

/**
 * Gets the initial path to be redirected to after a successful login.
 * This path is mostly dependent on the user type and their access role permissions.
 * @param userType The type of user logging in.
 * @param accessRoles List of access roles assigned to the user.
 * @param appConfigData Current app configuration, used to evaluate feature flags.
 * @returns Path to be redirected to.
 */
export const getLoginRedirectPath = (userType: USER_TYPE, accessRoles: AccessRole[] = [], appConfigData?: AppConfigData | null): string =>
  sessionStorage.getItem('attemptedRoute') || getDefaultLandingPath(userType, accessRoles, appConfigData);
